import { useMutation, useQueryClient } from 'react-query';
import { getSingleBlobAPI } from '@myme/api';
import { editBlob } from '@myme/logic';
import { BlobEditor } from '@myme/utils';
import { useTranslation } from 'src/hooks';
import { toast, ToastType } from 'src/utils';
import { BlobEditorAction } from './types';

const handleMapBlobToBeEdited = (blob: BlobEditor) => {
  if (blob.type === 'QUIZ') {
    return {
      ...blob,
      questions: blob.questions?.map(singleQuestion => ({
        id: !singleQuestion.isNew ? singleQuestion.id : null,
        content: singleQuestion.content,
        type: singleQuestion.type,
        answers: singleQuestion.answers?.map(singleAnswer => ({
          id: !singleAnswer.isNew ? singleAnswer.id : null,
          content: singleAnswer.content,
          isCorrect: singleAnswer.isCorrect
        }))
      }))
    };
  }
  return blob;
};

export const useEditBlobMutation = (blob: BlobEditor, dispatch: React.Dispatch<BlobEditorAction>) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const editBlobMutation = useMutation(async () => editBlob(blob.id, handleMapBlobToBeEdited(blob)), {
    onSuccess: () => {
      toast(ToastType.SUCCESS, t('pages.mymes.editor.blobs.editor.edit_toast_success'));
      queryClient.refetchQueries(getSingleBlobAPI.cacheKeys);
      dispatch({ type: 'BLOB_SUCCESSFULLY_EDITED' });
    }
  });

  return editBlobMutation;
};
